<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              需求信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <!-- <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogAddEditForm.typeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市场">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="需求方"
                    prop="demandSide"
                  >
                    <el-input v-model="dialogAddEditForm.demandSide" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="需求来源"
                    prop="schemeContent"
                  >
                    <el-input
                      v-model="dialogAddEditForm.schemeContent"
                      type="textarea"
                      placeholder="请输入需求来源"
                      :rows="3"
                      maxlength="1000"
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="收货库房"
                    prop="receiveDepotId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.receiveDepotId"
                      filterable
                      clearable
                      placeholder="请选择库房"
                      style="width:100%"
                      @change="receiveDepotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货人">
                    <el-input
                      v-model="dialogAddEditForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货联系电话">
                    <el-input
                      v-model="dialogAddEditForm.receivePhone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货地址">
                    <el-input
                      v-model="dialogAddEditForm.receiveAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              申请信息
              <el-button
                plain
                size="mini"
                icon="el-icon-circle-plus-outline"
                style="float:right; margin-top:0.1em; margin-right:15px;"
                @click="addDemandMaterialsFun"
              >
                添加需求物料
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="dialogAddEditForm.demandMaterialsData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      label="需求物料类别"
                      align="center"
                      width="180"
                    >
                      <template slot-scope="scope">
                        <el-form-item>
                          <el-select
                            v-model="scope.row.sortId"
                            filterable
                            clearable
                            placeholder="请选择需求物料类别"
                            style="width:100%"
                            @change="materialsSortChangeFun(scope.row, $event)"
                          >
                            <el-option
                              v-for="item in sortOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="需求物料名称"
                      header-align="center"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'demandMaterialsData.' + scope.$index + '.materialsId'"
                          :rules="dialogAddEditFormRules.materialsId"
                        >
                          <el-select
                            v-model="scope.row.materialsId"
                            filterable
                            clearable
                            placeholder="请选择需求物料"
                            style="width:100%"
                            @change="materialsChangeFun(scope.row, $event)"
                          >
                            <el-option
                              v-for="item in scope.row.materialsOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                              <span style="float: left">{{ item.label }}</span>
                              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeValue }}</span>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="materialsSpecification"
                      label="需求物料规格"
                      align="center"
                      width="105"
                    />
                    <el-table-column
                      prop="materialsUnitName"
                      label="需求物料单位"
                      align="center"
                      width="105"
                    />
                    <el-table-column
                      prop="applyMakeNumber"
                      label="申请制作数量"
                      align="center"
                      width="150"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'demandMaterialsData.' + scope.$index + '.applyMakeNumber'"
                          :rules="dialogAddEditFormRules.applyMakeNumber"
                        >
                          <el-input
                            v-model="scope.row.applyMakeNumber"
                            @input="(val)=>{limitPositiveNumber(val, scope.row, 'applyMakeNumber')}"
                            @blur="setNumberValueDefaultZero($event, scope.row, 'applyMakeNumber', 2);"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="60"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <i
                          class="el-icon-delete"
                          style="color: red; font-size: 16px;"
                          @click="handleDeleteMaterials(scope.$index)"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据字典API
import { listDictApi } from '@/api/v2/dict';
// 物料API
import { listMaterialsApi } from '@/api/v2/materials';
// 数据请求
import { saveMaterialsDemandApi } from '@/api/materialsDemandDetail'
import { depotListSelectDataApi } from '@/api/depot';

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data () {
    // 申请制作数量
    const validateApplyMakeNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入申请制作数量'))
      } else if (Number(value) === 0) {
        callback(new Error('申请制作数量必须大于0'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        receiveDepotId: [{ required: true, message: '请选择物料收货库房', trigger: 'change' }],
        materialsId: [{ required: true, message: '请选择需求物料', trigger: 'change' }],
        applyMakeNumber: [{ required: true, validator: validateApplyMakeNumber, trigger: 'blur' }],
        schemeContent: [{ required: true, message: '请输入需求来源', trigger: 'blur' }, { max: 1000, message: '需求来源最多输入1000个字符', trigger: 'blur' }],
        demandSide: [{ required: true, message: '请输入需求方', trigger: 'blur' }, { max: 32, message: '需求方最多输入32个字符', trigger: 'blur' }],
        remark: [{ max: 255, message: '备注最多输入255个字符', trigger: 'blur' }]
      },
      sortOptions: [],
      materialsOptions: [],
      depotOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.sortOptions = []
        _this.materialsOptions = []
        _this.depotOptions = []
        _this.dialogAddEditForm = {
          type: 2,
          typeValue: '方案外需求',
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          schemeContent: '',
          demandSide: '',
          isExecute: 1,
          demandSort: 1, // 需求方式
          executeMethod: 1, // 需求执行方式
          receiveDepotId: '', // 制作物料收货库房ID
          receiveDepotName: '', // 制作物料收货库房名称
          receiverId: 0, // 制作物料收货人ID
          receiver: '', // 制作物料收货人姓名
          receivePhone: '', // 制作物料收货联系电话
          receiveAddress: '', // 制作物料收货地址
          remark: '',
          demandMaterialsData: [],
          demandMaterialsDataJson: '' // 需求物料集合JSON字符串
        }
        // 获取物料类别选项
        _this.initSortSelectData()
        // 获取物料下拉选择项
        _this.initMaterialsData(null)
        // 获取收货库房选项数据
        _this.initDepotSelectData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    // 初始市场本地仓库下拉数据
    initDepotSelectData () {
      depotListSelectDataApi({ status: "1", isFixedAsset: "2", filterUserCity: "true", notManage: "true" }).then(response => {
        response.data.forEach(item => {
          this.depotOptions.push({
            label: item.name,
            value: item.id,
            provinceId: item.provinceId || 0,
            provinceName: item.provinceName || '',
            cityId: item.cityId || 0,
            cityName: item.cityName || '',
            receiverId: item.receiverId || 0,
            receiverName: item.receiverName || '',
            receivePhone: item.phone || '',
            receiveAddress: item.receiveAddress || ''
          })
        })
      })
    },
    // 选择库房回调
    receiveDepotChangeFun (val) {
      let selectItem = {}
      selectItem = this.depotOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.receiveDepotName = selectItem ? selectItem.label : ''
      this.dialogAddEditForm.receiverId = selectItem ? selectItem.receiverId : 0
      this.dialogAddEditForm.receiver = selectItem ? selectItem.receiverName : ''
      this.dialogAddEditForm.receivePhone = selectItem ? selectItem.receivePhone : ''
      this.dialogAddEditForm.receiveAddress = selectItem ? selectItem.receiveAddress : ''
      this.dialogAddEditForm.provinceId = selectItem ? selectItem.provinceId : 0
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.provinceName : ''
      this.dialogAddEditForm.cityId = selectItem ? selectItem.cityId : 0
      this.dialogAddEditForm.cityName = selectItem ? selectItem.cityName : ''
    },
    // 初始类别下拉数据
    initSortSelectData () {
      listDictApi({ type: 2 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.sortOptions.push({ label: item.optionLabel, data: item.optionValue })
        })
      })
    },
    // 物料类别选择回调
    materialsSortChangeFun (row, val) {
      let _this = this
      if (val) {
        row.materialsOptions = _this.materialsOptions.filter(item => item.sortId === val)
        row.materialsId = ''
        row.materialsSpecification = ''
        row.materialsUnitName = ''
        row.materialsUnitId = 0
      } else {
        row.materialsOptions = _this.materialsOptions
      }
    },
    // 获取物料下拉框数据
    initMaterialsData () {
      listMaterialsApi({ sortIds: '1, 2, 5', orderSort: 'sort_id, brand_id asc' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.materialsOptions.push({
            label: item.name, value: item.id, sortId: item.sortId, unitName: item.minimumUnit, unitId: 0, specification: item.specification, typeValue: item.sortName + ' - ' + item.brandName
          })
        })
      })
    },
    // 选择物料回调
    materialsChangeFun (row, val) {
      let selectedItem = {}
      selectedItem = this.materialsOptions.find(item => {
        return item.value === val
      })
      if (!row.sortId) {
        row.sortId = selectedItem.sortId || ''
      }
      row.materialsName = selectedItem.label || ''
      row.materialsUnitId = selectedItem.unitId || 0
      row.materialsUnitName = selectedItem.unitName || ''
      row.materialsSpecification = selectedItem.specification || ''
    },
    // 增加需求物料
    addDemandMaterialsFun () {
      let _this = this
      _this.dialogAddEditForm.demandMaterialsData.push(
        { sortId: '', materialsId: '', materialsName: '', materialsUnitId: 0, materialsUnitName: '', materialsSpecification: '', applyMakeNumber: 0, materialsOptions: _this.materialsOptions }
      )
    },
    // 删除需求物料
    handleDeleteMaterials (index) {
      this.dialogAddEditForm.demandMaterialsData.splice(index, 1)
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      // 验证是否存在需求物料
      if (_this.dialogAddEditForm.demandMaterialsData.length === 0) {
        _this.$message({ message: '未录入需求物料，不能保存', type: 'warning' })
        return false
      }
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          _this.$confirm(
            '是否确定新增物料需求申请', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            // 验证申请的物料是否存在重复的
            let materialsCountMap = new Map()
            _this.dialogAddEditForm.demandMaterialsData.forEach(item => {

              let materialsName = item.materialsName
              let existCount = 1
              if (materialsCountMap.get(materialsName)) {
                existCount = existCount + materialsCountMap.get(materialsName)
              }
              materialsCountMap.set(materialsName, existCount)
            })
            for (var [key, value] of materialsCountMap) {
              if (value > 1) {
                _this.$message({ message: '需求物料[' + key + ']重复存在，请删除重复项', type: 'warning' })
                return false
              }
            }
            _this.operateButtonDisable = true
            _this.loading = true
            _this.loadingText = '正在处理数据中，请耐心等待'

            _this.dialogAddEditForm.applyTotal = Number(_this.mathApplyTotal)
            let filterColumns = ['materialsId', 'materialsName', 'materialsUnitId', 'materialsUnitName', 'materialsSpecification', 'applyMakeNumber']
            _this.dialogAddEditForm.demandMaterialsDataJson = JSON.stringify(_this.dialogAddEditForm.demandMaterialsData, filterColumns)
            if (this.eventType === 'add') {
              _this.dialogAddEditForm.demandMaterialsData = []
            }
            saveMaterialsDemandApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                _this.$message({ message: res.message, type: 'success' })
                _this.reloadData()
                _this.modalClose()
              }
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}

.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
